import React, { useState } from "react";
import { Copy, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import AiPageShell from "../../components/ai/AiPageShell";
import { akilBasvuruMetni } from "../../lib/akilApi";

export default function AkilBasvuruMetniPage() {
    const [dosyaNo, setDosyaNo] = useState("");
    const [dosyaId, setDosyaId] = useState("");
    const [not, setNot] = useState("");
    const [metin, setMetin] = useState("");
    const [loading, setLoading] = useState(false);

    const uret = async () => {
        if (!dosyaNo.trim() && !dosyaId.trim()) {
            toast.error("Dosya no veya ID girin.");
            return;
        }
        setLoading(true);
        try {
            const data = await akilBasvuruMetni({
                dosya_no: dosyaNo.trim() || undefined,
                sigorta_dosyasi_id: dosyaId.trim() ? Number(dosyaId) : undefined,
                not: not.trim() || undefined,
            });
            if (!data.success) throw new Error(data.error);
            setMetin(data.metin || "");
            toast.success("Mail taslağı hazır.");
        } catch (err) {
            toast.error(err.response?.data?.error || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AiPageShell
            title="Sigorta Başvuru Metni"
            subtitle="Dosya bilgilerinden sigorta şirketine gidecek resmi e-posta taslağı üretin."
        >
            <div className="grid lg:grid-cols-2 gap-6">
                <div className="rounded-2xl border border-white/10 bg-[#121A2F]/60 p-5 space-y-4">
                    <label className="block text-xs text-slate-400">
                        Dosya No
                        <input
                            value={dosyaNo}
                            onChange={(e) => setDosyaNo(e.target.value)}
                            placeholder="MBS-19-05-2026-06"
                            className="mt-1 w-full rounded-lg bg-[#0B0F19] border border-white/10 px-3 py-2 text-sm"
                        />
                    </label>
                    <label className="block text-xs text-slate-400">
                        veya Dosya ID
                        <input
                            value={dosyaId}
                            onChange={(e) => setDosyaId(e.target.value)}
                            placeholder="147"
                            className="mt-1 w-full rounded-lg bg-[#0B0F19] border border-white/10 px-3 py-2 text-sm"
                        />
                    </label>
                    <label className="block text-xs text-slate-400">
                        Ek not (isteğe bağlı)
                        <textarea
                            value={not}
                            onChange={(e) => setNot(e.target.value)}
                            rows={3}
                            className="mt-1 w-full rounded-lg bg-[#0B0F19] border border-white/10 px-3 py-2 text-sm"
                            placeholder="Örn: eksik evrak listesine ruhsat ekleyin"
                        />
                    </label>
                    <button
                        type="button"
                        disabled={loading}
                        onClick={uret}
                        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#D4AF37] text-black text-sm font-bold disabled:opacity-50"
                    >
                        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />}
                        Taslak Oluştur
                    </button>
                </div>

                <div className="rounded-2xl border border-white/10 bg-[#121A2F]/60 p-5 flex flex-col min-h-[320px]">
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="text-sm font-semibold text-[#F3E5AB]">E-posta taslağı</h2>
                        {metin ? (
                            <button
                                type="button"
                                onClick={() => {
                                    navigator.clipboard.writeText(metin);
                                    toast.success("Panoya kopyalandı.");
                                }}
                                className="inline-flex items-center gap-1 text-xs text-slate-400 hover:text-white"
                            >
                                <Copy className="h-3.5 w-3.5" /> Kopyala
                            </button>
                        ) : null}
                    </div>
                    <textarea
                        value={metin}
                        onChange={(e) => setMetin(e.target.value)}
                        className="flex-1 min-h-[240px] w-full rounded-xl bg-[#0B0F19] border border-white/10 px-4 py-3 text-sm leading-relaxed resize-y"
                        placeholder="Taslak burada görünecek — düzenleyip sigorta başvuru modülünde kullanabilirsiniz."
                    />
                </div>
            </div>
        </AiPageShell>
    );
}
